import { render, staticRenderFns } from "./AddNewAndEditDeleteOrderReason.vue?vue&type=template&id=3d4d7768&scoped=true"
import script from "./AddNewAndEditDeleteOrderReason.vue?vue&type=script&lang=js"
export * from "./AddNewAndEditDeleteOrderReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d7768",
  null
  
)

export default component.exports